export const ROUTE_PATH = '/clean/cleaner/announcements' as const
